import { SC, SL, ROLES } from "../../config";

export function Badge({ status }) {
  return <span className={`px-2 py-0.5 rounded text-xs font-semibold ${SC[status] || "bg-gray-100 text-gray-600"}`}>{SL[status] || status}</span>;
}

export function RoleBadge({ role }) {
  const r = ROLES[role];
  if (!r) return null;
  return <span className={`px-2 py-0.5 rounded text-xs font-semibold ${r.color}`}>{r.label}</span>;
}
